import React from 'react';
import {MainLayout} from 'components/layouts';
import BannerCategory from 'components/fair/BannerCategory.jsx';
import {Fairs} from 'base/api';
import {Link} from 'react-router-dom';

class FairBannerCategory extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      fair: {}
    }
  }

  componentDidMount() {
    Fairs.actions.get.request({id: this.props.match.params.id}).then(response => {
      this.setState({
        fair: response.data && response.data.fair
      })
    })
  }

  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fair/${this.props.match.params.id}`}><i className='fa fa-chevron-left' />Quay về trang chi tiết</Link>
          </div>
          <div className='wrap-heading'>
            <h1>Quản lý banner danh mục</h1>
          </div>
          <BannerCategory fair={this.state.fair}/>
        </div>
      </MainLayout>
    );
  }
}

FairBannerCategory.contextTypes = {
  router: React.PropTypes.object
};

export default FairBannerCategory;


// WEBPACK FOOTER //
// ./pages/fair/FairBannerCategory.jsx